import React from 'react'
import { printType } from '../../constants/orderType'
import OrderItemInfo from '../order/OrderItemInfo'
import InvoiceHeader from '../order/InvoiceHeader'
import InvoiceFooter from '../order/InvoiceFooter'
import CustomerSignature from './CustomerSignature'

const PackingListToPrint = React.forwardRef(
    ({ order, type = printType.PACKING_LIST }, ref) => (
        <div className="invoice-container" ref={ref}>
            <div className="invoice-content">
                <InvoiceHeader order={order} type={type} />
                <div style={{ marginTop: '30px' }} />
                <div className="order-product-items">
                    <OrderItemInfo order={order} showStock={false} />
                </div>
                <div style={{ marginTop: '30px' }} />
                <InvoiceFooter type={type} />
                <CustomerSignature />
            </div>
        </div>
    )
)

export default PackingListToPrint
